const modulePrefix = 'modals';

export default {
    SET_MODAL_VISIBILITY: `${modulePrefix}/SET_MODAL_VISIBILITY`,
};
